import { clsx } from "clsx";
import { FormattedMessage } from "react-intl";
import BaseLinkOrButton from "./BaseLinkOrButton.tsx";
import styles from "./MoreButton.module.scss";
import { ComponentPropsWithoutRef, ReactNode } from "react";
import LoaderButton from "./LoaderButton.tsx";

type MoreButtonProps = ComponentPropsWithoutRef<"button"> & {
  hasMore: boolean;
  onMoreClick?: () => void;
  wrapped?: boolean;
  className?: string;
  loading?: boolean;
};

export function MoreButton({
  hasMore,
  onMoreClick,
  wrapped,
  className,
  loading,
  ...restProps
}: MoreButtonProps): ReactNode {
  if (!hasMore) {
    return null;
  }
  const props = {
    className: clsx(
      "vst-button-pill",
      "vst-button-variant-outline",
      styles.moreButton,
      className
    ),
    onClick: onMoreClick,
    ...restProps,
  };

  const caption = <FormattedMessage defaultMessage="Load More" />;

  const btn =
    loading !== undefined ? (
      <LoaderButton
        {...props}
        loading={loading}
        loaderProps={{ color: "thematic" }}
      >
        {caption}
      </LoaderButton>
    ) : (
      <BaseLinkOrButton {...props}>{caption}</BaseLinkOrButton>
    );

  return wrapped ? <div className={styles.wrapper}>{btn}</div> : btn;
}

export default MoreButton;
